/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import items from './items';
import edits from './edits';

export default combineReducers({
	items,
	edits,
});
